import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../style/gstheme';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { DropTarget } from 'react-dnd';

const styles = theme => {
    return Object.assign({
        tsvOptionSeparator: {
            float: 'left',
            height: 114,
            paddingTop: 78,
            width: 40,
            textAlign: 'center',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        tsvOptionSeparatorDrop: {
            float: 'left',
            height: 192,
            width: 40
        },
        tsvOptionSeparatorDropInner: {
            height: 192,
            backgroundColor: '#97D700',
            margin: '0px 19px 0px 19px',
            width: 4
        }
    }, globalStyles);
};

const target = {
    canDrop(props) {
        return props.canDrop;
    },
    drop(props, monitor) {
        const item = monitor.getItem();
        if (props.index > item.index) {
            props.moveOption(item.index, props.index);
        }
        else {
            props.moveOption(item.index, props.index + 1);
        }
    }
};

const Types = {
    TSVPROP: 'TsvProp'
};

function collectTarget(connect, monitor) {
    return {
        canDrop: monitor.canDrop(),
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver()
    };
}

class TSVoptionSeparator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {

        const { isOver, canDrop, classes, onClick, connectDropTarget, index, disabled } = this.props;

        return connectDropTarget(
            <div data-test={"column-separator-" + index}>
                {isOver && canDrop ?
                    <div data-highlight={true} className={classes.tsvOptionSeparatorDrop} >
                        <div className={classes.tsvOptionSeparatorDropInner} />
                    </div>
                    :
                    <div data-highlight={false} className={classes.tsvOptionSeparator}>
                        <Tooltip title="Switch columns">
                            <IconButton disabled={disabled} data-test="drag-button" size="small" onClick={onClick}>
                                <SwapHorizIcon style={{ color: '#9e9e9e' }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                }
            </div>
        );

    }
}

TSVoptionSeparator.propTypes = {
    isOver: PropTypes.bool,
    canDrop: PropTypes.bool,
    disabled: PropTypes.bool,
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    connectDropTarget: PropTypes.func
};

const tos = DropTarget([Types.TSVPROP], target, collectTarget)(TSVoptionSeparator);

export default withStyles(styles)(tos);